// @flow

import * as React from 'react';
import { useState } from 'react';
import type { Node } from 'react';

import './style.scss';

import languagesOptions from 'constants/languagesOptions';
import popularityOptions from 'constants/popularityOptions';

import SelectInput from 'components/SelectInput';
import Button from 'components/Button';

type Props = {
  onSubmit: () => void,
};

export default function SearchForm(props: Props): Node {
  const { onSubmit } = props;

  const [language, setLanguage] = useState('');
  const [popularity, setPopularity] = useState('');

  return (
    <form
      className="SearchForm__form"
      onSubmit={(e) => {
        onSubmit(e, { language, popularity });
      }}
    >
      <div className="SearchForm__input">
        <SelectInput
          id="language"
          label="programming language"
          options={languagesOptions}
          placeholder="eg. Javascript"
          value={language}
          onChange={({ value }) => setLanguage(value)}
        />
      </div>
      <div className="SearchForm__input">
        <SelectInput
          id="popularity"
          label="issue popularity"
          options={popularityOptions}
          placeholder="eg. Low"
          value={popularity}
          onChange={({ value }) => setPopularity(value)}
        />
      </div>
      <Button type="submit">Search</Button>
    </form>
  );
}
